/**
 * Case / session note bodies are stored as Base64-encoded HTML (`CareCaseNote.note`,
 * `CareSessionNote.note`, `RegistrationNote.note`). These wrap the encode/decode round-trip,
 * including the UTF-8 dance `btoa`/`atob` need for non-ASCII text.
 *
 * Both fall back to returning the input untouched, so a plain-text note that was never encoded
 * still renders rather than blowing up.
 */

/** Base64 → HTML string. */
export function decodeNote(value: string): string {
  try {
    return decodeURIComponent(escape(atob(value)));
  } catch {
    return value;
  }
}

/** HTML string → Base64. */
export function encodeNote(value: string): string {
  try {
    return btoa(unescape(encodeURIComponent(value)));
  } catch {
    return value;
  }
}
